module.exports = __webpack_public_path__ + "static/media/neutral_tan.1b6a0d75.jpg";